import React from "react";
import { DraftBox } from "src/components/Drafts";
import { FeedStackSection } from "src/components/FeedContainer";

export const ContentSectionBelowLg = () => {
  return (
    <FeedStackSection
      renderContent={(row, index) => <DraftBox key={index} row={row} />}
    />
  );
};
